module.exports = __webpack_public_path__ + "img/right-arrow.b203974e.svg";